import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=64d71a7c&scoped=true"
import script from "./SectionDetails.vue?vue&type=script&lang=ts"
export * from "./SectionDetails.vue?vue&type=script&lang=ts"
import style0 from "./SectionDetails.vue?vue&type=style&index=0&id=64d71a7c&prod&lang=scss"
import style1 from "./SectionDetails.vue?vue&type=style&index=1&id=64d71a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d71a7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VIcon,VNavigationDrawer,VRow})
